// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as ReactContext$LiveRoom from "../ReactContext.bs.js";
import * as Utils_Shared$LiveRoom from "../Utils/Utils_Shared.bs.js";
import * as ClientapiQueries$LiveRoom from "../ClientapiQueries.bs.js";
import * as RoundCurrencyFlag$LiveRoom from "../components/RoundCurrencyFlag.bs.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.bs.js";

var Context = ReactContext$LiveRoom.Make({
      defaultValue: undefined
    });

function formatAlternativeCurrency(amount, rate) {
  var alternativeCurrency = Curry._1(Context.use, undefined);
  var isCrypto = Belt_Option.mapWithDefault(alternativeCurrency, false, (function (x) {
          if (x.currency === "ETH") {
            return true;
          } else {
            return x.currency === "BTC";
          }
        }));
  try {
    return Utils_Shared$LiveRoom.Numbers.withCommasFloat(Caml_format.float_of_string(amount) * Caml_format.float_of_string(rate), isCrypto ? 2 : 0);
  }
  catch (exn){
    return "---";
  }
}

function useOnCurrencySelect(baseCurrency, setAlternativeCurrency) {
  var apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient(undefined);
  return React.useCallback((function (selectedCurrency) {
                if (Caml_obj.equal(baseCurrency, selectedCurrency)) {
                  return Curry._1(setAlternativeCurrency, undefined);
                }
                var $$let = ClientapiQueries$LiveRoom.AlternativeCurrency.CurrencyRatesQuery;
                Js_promise.then_((function (result) {
                        var rate;
                        rate = result.TAG === /* Ok */0 ? Belt_Array.getBy(result._0.data.currencies.targetCurrencies, (function (rate) {
                                  return Caml_obj.equal(rate.currency, selectedCurrency);
                                })) : undefined;
                        return Promise.resolve(Belt_Option.map(rate, (function (rate) {
                                          var alternativeCurrency_currency = rate.currency;
                                          var alternativeCurrency_rate = rate.rate;
                                          var alternativeCurrency = {
                                            currency: alternativeCurrency_currency,
                                            rate: alternativeCurrency_rate
                                          };
                                          Curry._1(setAlternativeCurrency, alternativeCurrency);
                                          return alternativeCurrency;
                                        })));
                      }), Curry._6(apolloClient.rescript_query, {
                          query: $$let.query,
                          Raw: $$let.Raw,
                          parse: $$let.parse,
                          serialize: $$let.serialize,
                          serializeVariables: $$let.serializeVariables
                        }, undefined, undefined, undefined, undefined, Curry._3(ClientapiQueries$LiveRoom.AlternativeCurrency.CurrencyRatesQuery.makeVariables, baseCurrency, typeof selectedCurrency === "object" ? [] : [selectedCurrency], undefined)));
              }), [baseCurrency]);
}

function AlternativeCurrency$CurrencyFlag(props) {
  var imgWidth = props.imgWidth;
  var imgHeight = props.imgHeight;
  var imgHeight$1 = imgHeight !== undefined ? imgHeight : 20;
  var imgWidth$1 = imgWidth !== undefined ? imgWidth : 20;
  var alternativeCurrency = Curry._1(Context.use, undefined);
  var selectedCurrencyType = alternativeCurrency !== undefined ? alternativeCurrency.currency : props.baseCurrency;
  return React.createElement(RoundCurrencyFlag$LiveRoom.make, {
              flagCode: selectedCurrencyType,
              styles: {
                hd: Css.height(Css.px(imgHeight$1)),
                tl: {
                  hd: Css.width(Css.px(imgWidth$1)),
                  tl: {
                    hd: Css.marginRight(Css.px(8)),
                    tl: /* [] */0
                  }
                }
              }
            });
}

var CurrencyFlag = {
  make: AlternativeCurrency$CurrencyFlag
};

var CurrencyRatesQuery = ClientapiQueries$LiveRoom.AlternativeCurrency.CurrencyRatesQuery;

export {
  CurrencyRatesQuery ,
  Context ,
  formatAlternativeCurrency ,
  useOnCurrencySelect ,
  CurrencyFlag ,
}
/* Context Not a pure module */
